// 北京小能咨询
const beijingZixun = {
  // <script src="http://bj.xdf.cn/bj_static/xdf_xcs/src/xcs.js" id="xdfcs" opt-color1="#03baa5" opt-color2="#ffa900" opt-rcsright="calc(50% - 505px)" opt-hide-template=""></script>
  replayes() {
    // 检测是否已加载
    let isLoaded = window.RCS && document.querySelector('script#xdfcs')
    if (isLoaded) return false;
    const script = document.createElement('script')
    script.id = 'xdfcs'
    let baseOpt = {
      'opt-color1': '#03baa5',
      'opt-color2': '#ffa900',
      'opt-rcsright': '10px',
      'opt-rcsbottom': '10px',
      'opt-hide-template': '',
      'src': 'http://bj.xdf.cn/bj_static/xdf_xcs/src/xcs.js'
    }
    for (const k in baseOpt) {
      script.setAttribute(k, baseOpt[k])
    }
    document.getElementsByTagName('body')[0].appendChild(script)
  },
  done(id) {
    try {
      window.RCS.showCommon(id || 'xd_1000_1557231408601');
    } catch (e) {
      alert('客服老师正在奔跑的路上，请稍后再试！')
    }
  }
}
// beijingZixun.replayes()
export const cityFormInfo = {
  '1': {
    'schoolId': 1,
    'cname': '北京',
    'shortkey': 'bj',
    'juniorTypeid': 4705,
    'highTypeid': 1581,
    'pcformId': 2553,
    'mformId': 2125,
    'zixun': 'http://chat.looyu.com/chat/chat/p.do?c=27975&f=56820&g=22906&refer=gdlj',
    'otherZixun': {
      done: beijingZixun.done
    }
  },
  '2': {
    'schoolId': 2,
    'cname': '上海',
    'shortkey': 'sh',
    'juniorTypeid': 4672,
    'highTypeid': 1554,
    'pcformId': 2554,
    'mformId': 2126,
    'configId': '32e9f85b-f810-48b1-8542-96e5b6ff9376'
  },
  '3': {
    'schoolId': 3,
    'cname': '广州',
    'shortkey': 'gz',
    'juniorTypeid': 4680,
    'highTypeid': 1552,
    'pcformId': 2555,
    'mformId': 2127,
    'configId': 'f528c0d2-53e2-4f55-8a0e-7f89a5fbda58'
  },
  '4': {
    'schoolId': 4,
    'cname': '武汉',
    'shortkey': 'wh',
    'juniorTypeid': 4700,
    'highTypeid': 1559,
    'pcformId': 2556,
    'mformId': 2128,
    'configId': 'e337fc4a-c40c-406c-b945-71296b1fa2f3'
  },
  '5': {
    'schoolId': 5,
    'cname': '天津',
    'shortkey': 'tj',
    'juniorTypeid': 4704,
    'highTypeid': 1549,
    'pcformId': 2557,
    'mformId': 2129,
    'configId': 'f67876dd-ed80-414a-8bec-2ad2328db831'
  },
  '6': {
    'schoolId': 6,
    'cname': '西安',
    'shortkey': 'xa',
    'juniorTypeid': 4686,
    'highTypeid': 1567,
    'pcformId': 2558,
    'mformId': 2130,
    'configId': 'e3167fec-271e-40f6-854f-e92265aefb9c'
  },
  '7': {
    'schoolId': 7,
    'cname': '南京',
    'shortkey': 'nj',
    'juniorTypeid': 4694,
    'highTypeid': 1550,
    'pcformId': 2559,
    'mformId': 2131,
    'configId': 'c5f5feec-522d-4007-bec9-919ec5c8d583'
  },
  '8': {
    'schoolId': 8,
    'cname': '深圳',
    'shortkey': 'sz',
    'juniorTypeid': 4680,
    'highTypeid': 1552,
    'pcformId': 2570,
    'mformId': 2132,
    'configId': '05073e93-c3f1-4447-a210-8e09f154c4b2'
  },
  '9': {
    'schoolId': 9,
    'cname': '沈阳',
    'shortkey': 'sy',
    'juniorTypeid': 4669,
    'highTypeid': 1553,
    'pcformId': 2581,
    'mformId': 2133,
    'configId': '8916e2da-53ce-40cc-b45c-0d528486969f'
  },
  '10': {
    'schoolId': 10,
    'cname': '重庆',
    'shortkey': 'cq',
    'juniorTypeid': 4673,
    'highTypeid': 1580,
    'pcformId': 2592,
    'mformId': 2134,
    'tenantId': 37608
  },
  '11': {
    'schoolId': 11,
    'cname': '成都',
    'shortkey': 'cd',
    'juniorTypeid': 4674,
    'highTypeid': 1579,
    'pcformId': 2605,
    'mformId': 2135,
    'configId': 'b59874f7-7658-4105-888a-0caf53cc94f8'
  },
  '14': {
    'schoolId': 14,
    'cname': '襄阳',
    'shortkey': 'xy',
    'juniorTypeid': 4700,
    'highTypeid': 1559,
    'pcformId': 2615,
    'mformId': 2136,
    'configId': 'ed47dc58-bb85-4dda-b472-4491e7c57066'
  },
  '15': {
    'schoolId': 15,
    'cname': '哈尔滨',
    'shortkey': 'heb',
    'juniorTypeid': 4682,
    'highTypeid': 1582,
    'pcformId': 2571,
    'mformId': 2137,
    'configId': '7189ffbd-7e2e-4d50-9995-a27dfd9504fd'
  },
  '16': {
    'schoolId': 16,
    'cname': '长沙',
    'shortkey': 'cs',
    'juniorTypeid': 4675,
    'highTypeid': 1543,
    'pcformId': 2582,
    'mformId': 2138,
    'configId': '73469c86-b70f-4eca-894e-0094bf2c833b'
  },
  '18': {
    'schoolId': 18,
    'cname': '长春',
    'shortkey': 'cc',
    'juniorTypeid': 4690,
    'highTypeid': 1588,
    'pcformId': 2567,
    'mformId': 2139,
    'configId': '38181aee-b033-4537-9ef6-a33e2b506139'
  },
  '19': {
    'schoolId': 19,
    'cname': '杭州',
    'shortkey': 'hz',
    'juniorTypeid': 4697,
    'highTypeid': 1557,
    'pcformId': 2593,
    'mformId': 2140,
    'configId': 'f59617ad-4e7b-43da-909a-0050467cf56b'
  },
  '20': {
    'schoolId': 20,
    'cname': '郑州',
    'shortkey': 'zz',
    'juniorTypeid': 4707,
    'highTypeid': 1561,
    'pcformId': 2606,
    'mformId': 2141,
    'configId': 'b0262a07-d6a1-4410-8917-40fae1b8642d'
  },
  '21': {
    'schoolId': 21,
    'cname': '太原',
    'shortkey': 'ty',
    'juniorTypeid': 4706,
    'highTypeid': 8518,
    'pcformId': 2616,
    'mformId': 2142,
    'configId': '2e2c7528-de1c-44a9-8ffa-d118ab8c1902'
  },
  '22': {
    'schoolId': 22,
    'cname': '济南',
    'shortkey': 'jn',
    'juniorTypeid': 4699,
    'highTypeid': 1555,
    'pcformId': 2561,
    'mformId': 2143,
    'configId': 'be67af17-3db7-432a-ab15-c51378c12631'
  },
  '23': {
    'schoolId': 23,
    'cname': '苏州',
    'shortkey': 'suzhou',
    'juniorTypeid': 4694,
    'highTypeid': 1550,
    'pcformId': 2572,
    'mformId': 2144,
    'configId': '0d91ede4-be56-4e13-a139-ac31ed2a3811'
  },
  '24': {
    'schoolId': 24,
    'cname': '石家庄',
    'shortkey': 'sjz',
    'juniorTypeid': 4703,
    'highTypeid': 1551,
    'pcformId': 2583,
    'mformId': 2145,
    'configId': '371ac913-71df-427f-b35e-36b4dc580ec0'
  },
  '25': {
    'schoolId': 25,
    'cname': '合肥',
    'shortkey': 'hf',
    'juniorTypeid': 4685,
    'highTypeid': 1593,
    'pcformId': 2594,
    'mformId': 2146,
    'configId': '5f6c1b77-9ee9-401d-ad93-98ab22295020'
  },
  '26': {
    'schoolId': 26,
    'cname': '福州',
    'shortkey': 'fz',
    'juniorTypeid': 4678,
    'highTypeid': 1566,
    'pcformId': 2607,
    'mformId': 2147,
    'configId': '6264f110-2d21-405d-bda7-e1471070383e'
  },
  '27': {
    'schoolId': 27,
    'cname': '昆明',
    'shortkey': 'km',
    'juniorTypeid': 4691,
    'highTypeid': 1587,
    'pcformId': 2617,
    'mformId': 2148,
    'configId': '5f9b277d-02bf-49fd-b870-53673f30a278'
  },
  '28': {
    'schoolId': 28,
    'cname': '鞍山',
    'shortkey': 'as',
    'juniorTypeid': 4669,
    'highTypeid': 1553,
    'pcformId': 2562,
    'mformId': 2149,
    'configId': 'f1e1c79b-6cd5-432a-8531-89787a38a50a'
  },
  '29': {
    'schoolId': 29,
    'cname': '株洲',
    'shortkey': 'zhuzhou',
    'juniorTypeid': 4675,
    'highTypeid': 1543,
    'pcformId': 2573,
    'mformId': 2150,
    'zixun': 'http://chat.looyu.com/chat/chat/p.do?c=27975&f=58197&g=23170&refer=gdlj'
  },
  '30': {
    'schoolId': 30,
    'cname': '佛山',
    'shortkey': 'fs',
    'juniorTypeid': 4680,
    'highTypeid': 1552,
    'pcformId': 2584,
    'mformId': 2151,
    'configId': '9b3e3ec2-4c1c-461d-8efb-14f9c36411b6'
  },
  '31': {
    'schoolId': 31,
    'cname': '宜昌',
    'shortkey': 'yc',
    'juniorTypeid': 4674,
    'highTypeid': 1579,
    'pcformId': 2595,
    'mformId': 2152,
    'configId': 'e337fc4a-c40c-406c-b945-71296b1fa2f3'
  },
  '32': {
    'schoolId': 32,
    'cname': '无锡',
    'shortkey': 'wx',
    'juniorTypeid': 4694,
    'highTypeid': 1550,
    'pcformId': 2608,
    'mformId': 2153,
    'configId': '69009600-0249-43a9-a313-295e8642cffe'
  },
  '34': {
    'schoolId': 34,
    'cname': '荆州',
    'shortkey': 'jz',
    'juniorTypeid': 4700,
    'highTypeid': 1559,
    'pcformId': 2618,
    'mformId': 2154,
    'configId': '6ada461b-77be-4c1b-92bd-861ac0762cd4'
  },
  '35': {
    'schoolId': 35,
    'cname': '南昌',
    'shortkey': 'nc',
    'juniorTypeid': 4695,
    'highTypeid': 1571,
    'pcformId': 2563,
    'mformId': 2155,
    'configId': 'b3f64815-ddec-476c-a816-4e51314fbab6'
  },
  '36': {
    'schoolId': 36,
    'cname': '大连',
    'shortkey': 'dl',
    'juniorTypeid': 4669,
    'highTypeid': 1553,
    'pcformId': 2574,
    'mformId': 2156,
    'configId': 'c653bdd5-2ade-4c6e-a5d1-67bd4ce30abc'
  },
  '37': {
    'schoolId': 37,
    'cname': '黄石',
    'shortkey': 'hs',
    'juniorTypeid': 4700,
    'highTypeid': 1559,
    'pcformId': 2585,
    'mformId': 2157,
    'configId': 'dba5f0e8-f847-4c75-839d-165b8201b26c'
  },
  '38': {
    'schoolId': 38,
    'cname': '宁波',
    'shortkey': 'nb',
    'juniorTypeid': 4697,
    'highTypeid': 1557,
    'pcformId': 2596,
    'mformId': 2158,
    'configId': 'e3c06d94-389d-4e03-b6b4-e0e2c5e9e6de'
  },
  '40': {
    'schoolId': 40,
    'cname': '兰州',
    'shortkey': 'lz',
    'juniorTypeid': 4692,
    'highTypeid': 1586,
    'pcformId': 2609,
    'mformId': 2159,
    'configId': 'e4bb4e8b-001a-4686-885c-f221dd6972a1'
  },
  '41': {
    'schoolId': 41,
    'cname': '厦门',
    'shortkey': 'xm',
    'juniorTypeid': 4678,
    'highTypeid': 1566,
    'pcformId': 2619,
    'mformId': 2160,
    'configId': '5ea2066a-dc5e-4844-86a6-78b16ab74fc1'
  },
  '44': {
    'schoolId': 44,
    'cname': '青岛',
    'shortkey': 'qd',
    'juniorTypeid': 4699,
    'highTypeid': 1555,
    'pcformId': 2564,
    'mformId': 2161,
    'configId': 'c3d9855c-5fd1-4adb-b6c8-8c4b58cb88be'
  },
  '45': {
    'schoolId': 45,
    'cname': '南宁',
    'shortkey': 'nn',
    'juniorTypeid': 4696,
    'highTypeid': 1570,
    'pcformId': 2575,
    'mformId': 2162,
    'configId': 'b654ce8f-a55c-4fbf-8266-1f9bf79550c8'
  },
  '46': {
    'schoolId': 46,
    'cname': '徐州',
    'shortkey': 'xz',
    'juniorTypeid': 4694,
    'highTypeid': 1550,
    'pcformId': 2586,
    'mformId': 2163,
    'configId': 'db59a2b0-ef53-4ca4-a5ee-945929002462'
  },
  '48': {
    'schoolId': 48,
    'cname': '湘潭',
    'shortkey': 'xt',
    'juniorTypeid': 4675,
    'highTypeid': 1543,
    'pcformId': 2598,
    'mformId': 2164,
    'zixun': 'http://chat.looyu.com/chat/chat/p.do?c=27975&f=81356&g=33211&refer=gdlj'
  },
  '49': {
    'schoolId': 49,
    'cname': '镇江',
    'shortkey': 'zj',
    'juniorTypeid': 4694,
    'highTypeid': 1550,
    'pcformId': 2610,
    'mformId': 2165,
    'configId': '08e56951-54b4-463b-a723-6dbe7b6acdd6'
  },
  '50': {
    'schoolId': 50,
    'cname': '吉林',
    'shortkey': 'jl',
    'juniorTypeid': 4690,
    'highTypeid': 1588,
    'pcformId': 2620,
    'mformId': 2166,
    'configId': 'c67c0e36-e499-4ae2-a8a6-e6cd662a8366'
  },
  '52': {
    'schoolId': 52,
    'cname': '南通',
    'shortkey': 'nt',
    'juniorTypeid': 4694,
    'highTypeid': 1550,
    'pcformId': 2565,
    'mformId': 2167,
    'configId': '4d9a2aad-631d-4faf-b64c-979e4a667634'
  },
  '53': {
    'schoolId': 53,
    'cname': '洛阳',
    'shortkey': 'ly',
    'juniorTypeid': 4707,
    'highTypeid': 1561,
    'pcformId': 2576,
    'mformId': 2168,
    'configId': 'ba0c0bf4-5716-493c-b5a5-9994f142b6b6'
  },
  '54': {
    'schoolId': 54,
    'cname': '呼和浩特',
    'shortkey': 'hhht',
    'juniorTypeid': 4687,
    'highTypeid': 1592,
    'pcformId': 2587,
    'mformId': 2169,
    'configId': '44ad3861-5130-4df8-b2f4-d4c9bf59e241'
  },
  '55': {
    'schoolId': 55,
    'cname': '乌鲁木齐',
    'shortkey': 'wlmq',
    'juniorTypeid': 4689,
    'highTypeid': 1568,
    'pcformId': 2599,
    'mformId': 2170,
    'configId': '6b944ec2-688a-4c04-8429-4875b03f4735'
  },
  '56': {
    'schoolId': 56,
    'cname': '唐山',
    'shortkey': 'ts',
    'juniorTypeid': 4703,
    'highTypeid': 1551,
    'pcformId': 2611,
    'mformId': 2171,
    'configId': 'db60271d-abcd-4478-9bd8-95b42fd1aab7'
  },
  '57': {
    'schoolId': 57,
    'cname': '贵阳',
    'shortkey': 'gy',
    'juniorTypeid': 4681,
    'highTypeid': 1572,
    'pcformId': 2621,
    'mformId': 2172,
    'configId': 'eb816dac-af3f-41c2-a4f9-c8c6434c0e2d'
  },
  '58': {
    'schoolId': 58,
    'cname': '十堰',
    'shortkey': 'shiyan',
    'juniorTypeid': 4700,
    'highTypeid': 1559,
    'pcformId': 2566,
    'mformId': 2173,
    'zixun': 'http://chat.looyu.com/chat/chat/p.do?c=27975&f==57316&g=72623&refer=gdlj'
  },
  '59': {
    'schoolId': 59,
    'cname': '温州',
    'shortkey': 'wz',
    'juniorTypeid': 4697,
    'highTypeid': 1557,
    'pcformId': 2588,
    'mformId': 2175,
    'configId': '9152ec8e-28c3-4d5e-b5e9-2fb849c2003e'
  },
  '60': {
    'schoolId': 60,
    'cname': '烟台',
    'shortkey': 'yt',
    'juniorTypeid': 4699,
    'highTypeid': 1555,
    'pcformId': 2600,
    'mformId': 2176,
    'configId': '0bc10714-9bf1-4ac0-a20c-327605526d3d'
  },
  '61': {
    'schoolId': 61,
    'cname': '潍坊',
    'shortkey': 'wf',
    'juniorTypeid': 4699,
    'highTypeid': 1555,
    'pcformId': 2633,
    'mformId': '',
    'configId': '370584f3-6528-4aea-913f-bb60a72ba460'
  },
  '64': {
    'schoolId': 64,
    'cname': '珠海',
    'shortkey': 'zh',
    'juniorTypeid': 4680,
    'highTypeid': 1552,
    'pcformId': 2612,
    'mformId': 2177,
    'zixun': 'http://chat.looyu.com/chat/chat/p.do?c=27975&f=127813&g=91749&refer=gdlj'
  },
  '66': {
    'schoolId': 66,
    'cname': '扬州',
    'shortkey': 'yz',
    'juniorTypeid': 4694,
    'highTypeid': 1550,
    'pcformId': 2631,
    'mformId': '',
    'zixun': 'http://chat.looyu.com/chat/chat/p.do?c=27975&f=129297&g=92626&refer=gdlj'
  },
  '68': {
    'schoolId': 68,
    'cname': '保定',
    'shortkey': 'bd',
    'juniorTypeid': 4703,
    'highTypeid': 1551,
    'pcformId': 2622,
    'mformId': 2178,
    'zixun': 'http://chat.looyu.com/chat/chat/p.do?c=27975&f=129568&g=93186&refer=gdlj'
  },
  '69': {
    'schoolId': 69,
    'cname': '永川',
    'shortkey': 'bd',
    'juniorTypeid': 4673,
    'highTypeid': 1580,
    'pcformId': 2592,
    'mformId': 2134,
    'tenantId': 37608
  },
  '71': {
    'schoolId': 71,
    'cname': '锦州',
    'shortkey': 'jinzhou',
    'juniorTypeid': 4669,
    'highTypeid': 1553,
    'pcformId': 2591,
    'mformId': 2844,
    'configId': 'b92a6d4c-1c24-452f-8014-b3de85b04c16'
  },
  '82': {
    'schoolId': 82,
    'cname': '开封',
    'shortkey': 'kf',
    'juniorTypeid': 4707,
    'highTypeid': 1561,
    'pcformId': '',
    'mformId': 2364,
    'configId': 'c46b177b-e5b6-40e2-946e-d9904acb8ae7'
  },
  '83': {
    'schoolId': 83,
    'cname': '南阳',
    'shortkey': 'ny',
    'juniorTypeid': 4707,
    'highTypeid': 1561,
    'pcformId': '',
    'mformId': '',
    'configId': ''
  },
  '86': {
    'schoolId': 86,
    'cname': '盐城',
    'shortkey': 'yc',
    'juniorTypeid': 4694,
    'highTypeid': 1550,
    'pcformId': 2624,
    'mformId': 2364,
    'configId': '17a876d0-7347-4a18-968d-4b9e3b304e65'
  },
  '87': {
    'schoolId': 87,
    'cname': '连云港',
    'shortkey': 'lyg',
    'juniorTypeid': 4694,
    'highTypeid': 1550,
    'pcformId': 2978,
    'mformId': 2975,
    'configId': '3a723b97-3c1d-4653-912a-f1ceaf5019cc'
  },
  '130300': {
    'schoolId': 509,
    'cname': '秦皇岛',
    'shortkey': 'qhd',
    'juniorTypeid': 4703,
    'highTypeid': 1551,
    'pcformId': 2567,
    'mformId': 2179,
    'configId': '5034ce76-0837-4383-a96c-160e2c7e83ea'
  },
  '130400': {
    'schoolId': 73,
    'cname': '邯郸',
    'shortkey': 'hd',
    'juniorTypeid': 4703,
    'highTypeid': 1551,
    'pcformId': 2589,
    'mformId': 2181,
    'configId': '6d772f16-558a-4ce9-a0c9-17853df1eb2c'
  },
  '130900': {
    'schoolId': 508,
    'cname': '沧州',
    'shortkey': 'cz',
    'juniorTypeid': 4703,
    'highTypeid': 1551,
    'pcformId': 2578,
    'mformId': 2180,
    'configId': '6d86340d-c8e7-44ca-87cc-cd06a1dd46d2'
  },
  '410500': {
    'schoolId': 510,
    'cname': '安阳',
    'shortkey': 'ay',
    'juniorTypeid': 4707,
    'highTypeid': 1561,
    'pcformId': 2602,
    'mformId': 2182,
    'configId': 'd5e946bd-5d1d-4d40-a557-930e50415061'
  },
  '410700': {
    'schoolId': 518,
    'cname': '新乡',
    'shortkey': 'xx',
    'juniorTypeid': 4707,
    'highTypeid': 1561,
    'pcformId': 2912,
    'mformId': 2911,
    'configId': '27a1dd08-c9d7-4966-aaea-936687a0ebe0'
  },
  '441900': {
    'schoolId': 506,
    'cname': '东莞',
    'shortkey': 'dg',
    'juniorTypeid': 4680,
    'highTypeid': 1552,
    'pcformId': 2568,
    'mformId': '',
    'configId': '29fede08-d8b0-4e8c-809a-8494d7a0d3fd'
  },
  '442000': {
    'schoolId': 507,
    'cname': '中山',
    'shortkey': 'zs',
    'juniorTypeid': 4680,
    'highTypeid': 1552,
    'pcformId': 2590,
    'mformId': '',
    'configId': '2fa04ec8-fb06-41fc-833b-a297da49be52'
  },
  '460100': {
    'schoolId': 504,
    'cname': '海口',
    'shortkey': 'hk',
    'juniorTypeid': 4705,
    'highTypeid': 1581,
    'pcformId': 2579,
    'mformId': 2173,
    'configId': '6ec88dfe-5932-4d44-af40-d13d2a581bef'
  },
  '510700': {
    'schoolId': 517,
    'cname': '绵阳',
    'shortkey': 'mianyang',
    'juniorTypeid': 4674,
    'highTypeid': 1579,
    'pcformId': 2604,
    'mformId': 2636,
    'configId': '927959ed-fae9-4342-9953-737fddacabd4'
  },
  '640100': {
    'schoolId': 505,
    'cname': '银川',
    'shortkey': 'yc',
    'juniorTypeid': 4705,
    'highTypeid': 1581,
    'pcformId': 2623,
    'mformId': 2173,
    'configId': '1cf345bb-7f94-4a0b-8249-e8007b673b72'
  },
  '441300': {
    'schoolId': 520,
    'cname': '惠州',
    'shortkey': 'huizhou',
    'juniorTypeid': 4680,
    'highTypeid': 1552,
    'pcformId': 3131,
    'mformId': 3120,
    'configId': 'ac30f1ee-a747-4e94-a193-c396b0151fed'
  },
  '150200': {
    'schoolId': 521,
    'cname': '包头',
    'shortkey': 'bt',
    'juniorTypeid': 4687,
    'highTypeid': 1592,
    'pcformId': 3130,
    'mformId': 3121,
    'configId': 'a42dcf1d-db30-432e-8e13-0426b3b1d29e'
  },
  '630100': {
    'schoolId': 522,
    'cname': '西宁',
    'shortkey': 'xn',
    'pcformId': 3129,
    'mformId': 3122,
    'configId': '840eb6a6-7069-466e-83a6-a0bbb41dd7c5',
    'juniorTypeid': 4705,
    'highTypeid': 1581
  },
  130800: {
    schoolId: 130800,
    name: '承德',
    shortkey: "chengde",
    juniorTypeid: 4705,
    highTypeid: 1581,
    pformid: 3462,
    mformid: 3446,
    configId: '8ceeaab5-2fd6-4d56-b41a-e811dee45e28'
  },
  411000: {
    schoolId: 411000,
    name: '许昌',
    juniorTypeid: 4705,
    highTypeid: 1581,
    shortkey: "xc",
    pformid: 3464,
    mformid: 3447,
    configId: 'ffa0da98-4a6f-493c-bda2-3f09cb63544c'
  },
  410600: {
    schoolId: 410600,
    name: '鹤壁',
    shortkey: "hb",
    juniorTypeid: 4705,
    highTypeid: 1581,
    pformid: 3465,
    mformid: 3448,
    configId: 'fc7a3414-55b4-4172-ba8b-dd20253a288d'
  },
  130500: {
    schoolId: 130500,
    name: '邢台',
    shortkey: "xingtai",
    juniorTypeid: 4705,
    highTypeid: 1581,
    pformid: 3463,
    mformid: 3449,
    configId: 'de88be6e-57a3-44aa-a89b-50643c233627'
  },
  411700: {
    schoolId: 411700,
    name: '驻马店',
    shortkey: "zmd",
    juniorTypeid: 4705,
    highTypeid: 1581,
    pformid: 3466,
    mformid: 3450,
    configId: 'f29cd147-fc24-4d63-9ba6-e3d09d9cd8fe'
  },
  330600: {
    schoolId: 502,
    name: '绍兴',
    shortkey: "sx",
    juniorTypeid: 4705,
    highTypeid: 1581,
    pformid: 2580,
    mformid: 3189,
    configId: '75f9dded-ed66-4f49-bef0-f54d69d1affe'
  },
  330500: {
    schoolId: 503,
    name: '湖州',
    shortkey: "huzhou",
    juniorTypeid: 4705,
    highTypeid: 1581,
    pformid: 2569,
    mformid: 318,
    configId: '98b5eea5-b624-42b7-a387-6a0b1d16aee5'
  },
  "131000":{
    schoolId: 95,
    name: '廊坊',
    shortkey: "langfang",
  },
  "131100": {
    schoolId: 131100,
    name: '衡水',
    shortkey: "hengshui",
  },
  "320400": {
    schoolId: 320400,
    name: '常州',
    shortkey: "changzhou",
  },
  "320800": {
    schoolId: 320800,
    name: '淮安',
    shortkey: "huaian",
  },
  "321200": {
    schoolId: 321200,
    name: '泰州',
    shortkey: "taizhou",
  },
  "330400": {
    schoolId: 330400,
    name: '嘉兴',
    shortkey: "jx",
  },
  "331000": {
    schoolId: 331000,
    name: '台州',
    shortkey: "tz",
  },
  "360400": {
    schoolId: 360400,
    name: '九江',
    shortkey: "jj",
  },
  "370800": {
    schoolId: 370800,
    name: '济宁',
    shortkey: "jining",
  },
  "370900": {
    schoolId: 370900,
    name: '泰安',
    shortkey: "ta",
  },
  "411200": {
    schoolId: 411200,
    name: '三门峡',
    shortkey: "smx",
  },
  "411400": {
    schoolId: 411400,
    name: '商丘',
    shortkey: "sq",
  },
  "411500": {
    schoolId: 411500,
    name: '信阳',
    shortkey: "xinyang",
  },
  "411600": {
    schoolId: 411600,
    name: '周口',
    shortkey: "zk",
  },
  "610300": {
    schoolId: 610300,
    name: '宝鸡',
    shortkey: "baoji",
  },
  "610400": {
    schoolId: 610400,
    name: '咸阳',
    shortkey: "xianyang",
  },
}



// WEBPACK FOOTER //
// ./src/api/js/staticData.js